export default {
	common: {
		pl_search: '请输入搜索条件',
		handle: '操作',
		ends_at: '到期时间',
		created_at: '创建时间',
		pay_at: '支付时间',
		action_success: '操作成功',
		tip: '提示',
		cancel: '取消',
		confirm: '确定',
		unpaid: '未支付',
		paid: '已支付',
		payment_failed: '支付失败',
		cancelled: '已作废',
		edit_success: '修改成功',
		pl_start_at: '选择开始时间',
		pl_ends_at: '选择结束时间',
		back: '返回',
		msg_edit: '本次编辑的内容尚未保存，确定放弃修改吗？',
		msg_edit_title: '放弃当前更改内容？',
		submit_leave: '确定离开当前页面吗',
		start_at: '开始时间',
		end_at: '结束时间',
		msg_title: '确认执行此操作？',
		warning: '警告',
		close: '关闭',
		copy_success: '复制成功',
		copy_failed: '复制失败',
		more: '查看更多',
		gmt5: '(GMT-05:00) 美国东部时间',
		gmt8: '(GMT+08:00) 北京时间',
		'gmt-7': '(GMT-07:00) 亚利桑那时间',
		'gmt-8': '(GMT-08:00) 太平洋时间',
		'gmt-9': '(GMT-09:00) 阿拉斯加时间',
		man_refresh: '手动刷新',
		not_upload: '未上传',
		uploaded: '已上传',
		upload_fail: '上传失败',
	},
}
